import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/www/.buckydao-build-1607de7/src/app/components/DaoMembers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/www/.buckydao-build-1607de7/src/app/components/governance2/OverviewSnapshot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/www/.buckydao-build-1607de7/src/app/components/LatestProposals.tsx");
;
import(/* webpackMode: "eager" */ "/root/www/.buckydao-build-1607de7/src/node_modules/@ant-design/icons/es/components/AntdIcon.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/www/.buckydao-build-1607de7/src/node_modules/next/dist/client/app-dir/link.js");
